module.exports = __webpack_public_path__ + "static/media/silver.b2937687.svg";